var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 42C32.5979 42 42 32.5979 42 21C42 9.40212 32.5979 0 21 0C9.40212 0 0 9.40212 0 21C0 32.5979 9.40212 42 21 42ZM28.518 13.7029C30.13 13.8482 31.038 14.8348 31.2371 16.4069C31.3765 17.5039 31.5 19.0747 31.5 20.7644C31.5 23.7313 31.2371 25.4465 31.2371 25.4465C30.9901 27.0123 30.2333 27.8624 28.6415 28.0421C26.8628 28.2437 22.8623 28.3361 21.0848 28.3361C19.2452 28.3361 15.5253 28.2589 13.6676 28.1043C12.0716 27.9712 10.9822 27.0795 10.7629 25.4927C10.6033 24.3369 10.5 22.9635 10.5 20.7795C10.5 18.3485 10.5878 17.3195 10.794 16.2212C11.0876 14.6538 11.8356 13.8944 13.5442 13.718C15.3367 13.5328 17.031 13.44 20.8223 13.44C22.6758 13.44 26.6721 13.5358 28.518 13.7029ZM18.7673 17.8025V23.8396L24.5154 20.79L18.7673 17.8025Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.756d3fcd0c23849389019b4e2eb26c18.svg";
export { ForwardRef as ReactComponent };